export default {
	HEADER: 'Abort',
	SUBHEADER: 'Are you sure you want to close modal and reset all data?',
	CONFIRM: 'Close',
	CANCEL: 'Cancel'
};
